(function Module() {
	'use strict';
	mySynch.controller('PublishedReportV2_0Controller', [
		'$scope',
		'$rootScope',
		'$interval',
		'$q',
		'F360Service',
		'AuditService',
		'ApiFactory',
		'CookieFactory',
		'F360Constant',
		'F360ChartService',
		'$location',
		'$filter',
		'$window',
		'ViewAuthorizationFactory',
		'MySynchFactory',
		'mySynchEnumerationService',
		'performanceMetricsService',
		'performanceContextService',
		'clientLoggerService',
		function PublishedReportV2_0Controller($s,$rootScope,$interval,$q, f360Service, auditService,api,cookies,constant, ChartService, $location,$filter,$window,viewAuth,MSF,mySynchEnumSvc,perfMetricSvc, perfContextSvc, log) {
			window.scrollTo(0, 0);
			
		   $s.performanceContext = null;
			
			self.auditId = auditService.getAuditId($location.url());
			$s.breadcrumbs = [];
			$s.lastBreadcrumbs = {};

			$s.isOnline = $rootScope.onLine;
			
			$s.mySynchState = {};
			$s.activeFarm = {};
			$s.currentHerd = {};


			$s.overViewList = [];
			$s.auditAnswers = [];
			$s.auditQuestions = [];
			$s.auditQuestionsWithAnswers = [];

			$s.sectionsQuestionsAndAnswers = [];
			$s.structuredQuestionsAndAnswers = [];
			$s.actionItems = [];
			$s.defaultReportData = {"resultsWriteRptJson":{"formattedHighlights":"","nextEvaluationDate":"","comments":[{"category": "COMFRT","formattedComments":""},{"category": "NUTRIT","formattedComments":""},{"category": "DATAQUALITY","formattedComments":""},{"category": "REPROD","formattedComments":""},{"category": "DISEASE","formattedComments":""},{"category": "PERSON","formattedComments":""},{"category": "INFORM","formattedComments":""}]},"reviewDraftRptJson":{"reportDate":"","milkingCnt": null,"pregRate":null,"concRate":null,"reviewedReport":false,"actionItemGroups":[]}};
			$s.reportData = {};
			$s.report = angular.copy($s.defaultReportData);
			
			
			$s.actionItemStatuses = [];


			$s.followupItems = [];

			$s.actionItemGroups = [];
			$s.v2ActionItems = [];

			$s.codeFile = [];

            let testActionItemGroup = {
				actionItemGroupKey: "Fertility",
				description: "test action group involving Fertility",
				actionItems: [],
				associatedMetrics: ""
			};

			let testAssociatedMetrics = [
				{
					name: "Pregnancy Rate RHA"
				},
				{
					name: "Conception Rate RHA"
				}
			];

			

			let testActionItems = [
				{
					actionItemGroup : "Fertility",
					dueDate: moment(new Date(2022,12,15)).format('M/D/YYYY'),
					description: "This is free text copy entered by the vet creating an action item. This is free text copy entered by the vet creating an action item. This is free text copy entered by the vet creating an action item. This is free text copy entered by the vet creating an action item. ",
					personId: 1080,
					fullName: "Matthew Doucet",
					status: "A",
					dateCompleted: null,
					dateRemoved: null,
					currentFarmGoal: "Test Farm Goal"

				},
				{
					actionItemGroup : "Fertility",
					dueDate: moment(new Date(2022,12,16)).format('M/D/YYYY'),
					description: "This is a list of actions to complete to meet the goal.",
					personId: 1080,
					fullName: "Matthew Doucet",
					status: "A",
					dateCompleted: null,
					dateRemoved: null,
					currentFarmGoal: "Test Farm Goal"
				},
				{
					actionItemGroup : "Fertility",
					dueDate: moment(new Date(2022,12,17)).format('M/D/YYYY'),
					description: "Description goes here.",
					personId: 1080,
					fullName: "Matthew Doucet",
					status: "A",
					dateCompleted: null,
					dateRemoved: null,
					currentFarmGoal: "Test Farm Goal"
				}
			];

			
			
			$s.auditApiVersion;
			
			$s.currentAuditApiVersion;

			

			//------ chart model and data related variables
			$s.allMetGuidelineQuestions = [];
			$s.allOutsideGuidelineQuestions = [];
			$s.allMetGuidelineQuestionsWithGuidelines = [];
			$s.allOutsideGuidelineQuestionsWithGuidelines = [];


			$s.overallSummaryPieChart = {
				chart: {},
				title: "",
				seriesData: [] 
			};
			$s.categoryPieCharts = [];
            $s.sectionBarChart = {
				chart: {},
				title: "",
				seriesData: []
			};
			$s.categoryBarChart = {
				chart: {},
				title: "",
				seriesData: []
			};
              
			$s.questionSectionsPieChartData = [];
			$s.codeFileCurrentF360CategoryApiVersions = [];
			$s.codeFileQuestionSections = [];
			$s.codeFileQuestionSectionSubheadings = [];
			$s.codeFileQuestionCategories = [];
			$s.codeFileQuestionSubCategories = [];
			$s.codeFileQuestionOrders = [];
			$s.codeFileQuestionSubtitles = [];
		 
			
	     //----------------------------------------------------------

			$s.author = ""; 
			
			$s.minTargetDate = moment().set({'hour':0,'minute':0,'second':0,"millisecond":0}).toDate();//formatDate(new Date());
			$s.pregRateQuestionId = 170;
			$s.concRateQuestionId = 153;

			$s.canUpdate = false;
			$s.canView = false;

			// watcher degresigration variables
			var deregOnFarmChange = undefined;
			var deregOnlineCheckWatch = undefined;

			// flag for that is set true when and update answers call occurs successfuly without updating the server
			$s.syncInProgress = false;
			$s.isDirty = false;
			$s.updateInProgress = false;

		    $s.checkSyncStatusTimer = undefined;

			//------------------
			// TEMP CODE
            //------------------

			$s.setupTempFields = function setupTempFields(questions){

				_.forEach(questions,function(question){
					// target a set of questions for add bool "allowOptOut"
					  if(_.includes([2,3,13,14,24,25,35,36],_.get(question,'QuestionId'))){
							 _.set(question,'allowOptOut',true);
					  }else{
					   _.set(question,'allowOptOut',false);
					  }

					  if(_.includes([2,7,10,13,18,21,24,29,32,35,38,41,46,70,77,78,79,80],_.get(question,'QuestionId'))){
                               _.set(question,'Category','COMFRT');
							   if(_.includes([2,7,10,13],_.get(question,'QuestionId'))){
								_.set(question,'SubCategory','MGMT');
								_.set(question,'Subtitle','MGMT');
							   }

							   if(_.includes([18,21,24,29,32,35],_.get(question,'QuestionId'))){
								_.set(question,'SubCategory','FACILITY');
								_.set(question,'Subtitle','FACILITY');
							   }

							if(_.includes([38,41,46,70,77,78,79,80],_.get(question,'QuestionId'))){
								_.set(question,'SubCategory','OTHER');
								_.set(question,'Subtitle','OTHER');
							}
                             
				    	} 
					  // NUTR
					  if(_.includes([9,20,31,40,44,45],_.get(question,'QuestionId'))){
                           _.set(question,'Category','NUTRIT');
						   if(_.includes([9],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','FACILITY');
						   }

						   if(_.includes([20],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','WATER');
						   }

						if(_.includes([31],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','RATION');
						}
						if(_.includes([40],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','BCS');
						   }

						   if(_.includes([44],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','MGMT');
						   }

						if(_.includes([45],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','OTHER');
						}

                      // subtitles
						if(_.includes([9],_.get(question,'QuestionId'))){
							_.set(question,'Subtitle','WATER');
						}

						
						if(_.includes([20],_.get(question,'QuestionId'))){
							_.set(question,'Subtitle','BCS');
						}

						
						if(_.includes([31],_.get(question,'QuestionId'))){
							_.set(question,'Subtitle','MGMTFAC');
						}

						if(_.includes([40,44,45],_.get(question,'QuestionId'))){
							_.set(question,'Subtitle','RATION');
						}

					 } 
					  //DATAQLTY
					  if(_.includes([109,110,111,112,113,114,115,116,117,160,164,166,168,170,172,174],_.get(question,'QuestionId'))){
						_.set(question,'Category','DATAQUALITY');
						if(_.includes([109],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','REPROREC');
						   }
						   if(_.includes([110],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','TCD-RP');
						   }
						   if(_.includes([111],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','TCD-K');
						   }
						   if(_.includes([112],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','TCD-MF');
						   }
						   if(_.includes([113],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','TCD-MET');
						   }
						   if(_.includes([114],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','TCD-DA');
						   }
						   if(_.includes([115],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','MAST');
						   }
						   if(_.includes([116],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','DYSTOCIA');
						   }
						   if(_.includes([117,160],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','PNEUMONIA');
						   }
						   if(_.includes([164,166],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','LAMENESS');
						   }
						   if(_.includes([168,170],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','TWIN');
						   }
						   if(_.includes([172,174],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','STILLBIRTH');
						   }

						   	// subtitles 
							   if(_.includes([109,110,111,112,113,114],_.get(question,'QuestionId'))){
								_.set(question,'Subtitle','REPROD');
							   }
							   if(_.includes([115,116,117,160,164,166,168,170,172,174],_.get(question,'QuestionId'))){
								_.set(question,'Subtitle','DISEASE');
							   }


					} 
					  //REPRO
					  if(_.includes([119,121,122,123,124,125,126,127,128,129,130,131,132,133,134,135,136,137,138,139,140,141,142,143,144,145],_.get(question,'QuestionId'))){
						_.set(question,'Category','REPROD');

						   if(_.includes([119],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','PREG');
						   }
						   if(_.includes([121],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','PREG-VWP');
						   }
						   if(_.includes([122],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','INSEM');
						   }
						   if(_.includes([123],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','INSEM-MO');
						   }
						   if(_.includes([124],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','CONCEP');
						   }
						   if(_.includes([125],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','CONCEP-MO');
						   }
						   if(_.includes([126],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','CONCEP-LACT');
						   }
						   if(_.includes([127],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','CONCEP-SVC');
						   }
						   if(_.includes([128],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','CONCEP-TECH');
						   }
						   if(_.includes([129,130,131,132,133,134,135,136,137,138],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','CONCEP-SIRE');
						   }
						   if(_.includes([139,140,141,142,143,144,145],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','CONCEP-COMBO');
						   }

						   if(_.includes([119,121,122,123,124,125,126,127],_.get(question,'QuestionId'))){
							_.set(question,'Subtitle','PREG');
						   }
						   if(_.includes([128,129,130,131,132,133,134],_.get(question,'QuestionId'))){
							_.set(question,'Subtitle','INSEM');
						   }
							if(_.includes([135,136,137,138,139,140,141,142,143,144,145],_.get(question,'QuestionId'))){
								_.set(question,'Subtitle','CONCEP');
							}
					} 
					  //DISEASE
					  if(_.includes([6,17,28,120,149,151,153,155,157,159,163,165,167,173,175,176],_.get(question,'QuestionId'))){
						_.set(question,'Category','DISEASE');
						if(_.includes([119],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','MGMT');
						   }
						   if(_.includes([6],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','TCD');
						   }
						   if(_.includes([17],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','TCD-RP');
						   }
						   if(_.includes([28],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','TCD-K');
						   }
						   if(_.includes([120],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','TCD-MF');
						   }
						   if(_.includes([149],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','TCD-MET');
						   }
						   if(_.includes([151],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','TCD-DA');
						   }
						   if(_.includes([153],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','MAST');
						   }
						   if(_.includes([155],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','DYSTOCIA');
						   }
						   if(_.includes([157],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','PNEUMONIA');
						   }
						   if(_.includes([159],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','LAMENESS');
						   }
						   if(_.includes([163],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','TWIN');
						   }
						   if(_.includes([165],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','STILLBIRTH');
						   }
						   if(_.includes([167,173],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','CULL');
						   }
						   if(_.includes([175,176],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','OTHER');
						   }

						   // subtitle

						   if(_.includes([6,17,28,120,149,151,153,155,157,159,163,165,167,173,175,176],_.get(question,'QuestionId'))){
						    	_.set(question,'Subtitle','MGMT');
						   }
						  
					} 
					  //PERS
					  if(_.includes([63,64,65],_.get(question,'QuestionId'))){
						_.set(question,'Category','PERSON');

						   if(_.includes([63,64],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','TRAIN');
							_.set(question,'Subtitle','TRAIN');
						   }

						   if(_.includes([65],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','OTHER');
							_.set(question,'Subtitle','OTHER');
						   }
					} 
					  //CALC
					  if(_.includes([4,8,15,19,26,30,37,39],_.get(question,'QuestionId'))){
						_.set(question,'Category','CALCULA');
						if(_.includes([4,8,15],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','FACILITY');
						   }

						   if(_.includes([19,26,30,37,39],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','OTHER');
						   }

						   // subtitles
						   if(_.includes([4,8,15,19,26,30,37,39],_.get(question,'QuestionId'))){
							_.set(question,'Subtitle','OTHER');
						   }
					} 
					  //INFO
					  if(_.includes([3,5,11],_.get(question,'QuestionId'))){
						_.set(question,'Category','INFORM');
						if(_.includes([3,5,11],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','OTHER');
							_.set(question,'Subtitle','OTHER');
						   }
					} 
					  //PEN
                      if(_.includes([12,14,15],_.get(question,'QuestionId'))){
						_.set(question,'Category','PEN');
						if(_.includes([12,14,15],_.get(question,'QuestionId'))){
							_.set(question,'SubCategory','PEN');
							_.set(question,'Subtitle','PEN');
						   }
					} 
				 

				   // set DataRptSection

				   // set DataRptSubTitle

				   // set CategoryPenType
                       

					  var answer = _.get(question,'Answer');
					  if(!_.isUndefined(answer)){
						  if(_.isUndefined(answer,'IsOptedOut')){
							_.set(question,'Answer.IsOptedOut',false);
						  }
					   
					  }
				});

			};
			 
		   //------------------
			
			
			$s.checkPermissions = function checkPermissions(callback){

				
				
				if(  (viewAuth.hasRole(mySynchEnumSvc.getMySynchEnumeration('Role','SUPER_ADMIN'))) 
				  || (viewAuth.hasRole(mySynchEnumSvc.getMySynchEnumeration('Role','TERRITORY_MANAGER'))) 
				  || (viewAuth.hasRole(mySynchEnumSvc.getMySynchEnumeration('Role','ADMIN')) && viewAuth.hasPersonType(mySynchEnumSvc.getMySynchEnumeration('PersonType','VET')))){
					$s.canView = true;
				}

				
				// we need to check to see if the user who is viewing this screen is the person who create the audit
				// otherwise we need to redirect them to the top level f360 report
				auditService.getListByHerdId($s.performanceContext, function getF360ListByHerdId(err, data) {
					var currentAudit = _.find(data,{AuditId: self.auditId},'Name');

					var authorIds = _.map(MSF.parseJsonStringToArray(_.get(currentAudit,'Authors','[]'),"Failed to parse Authors in checkPermissions on Review Draft."), (author) => _.get(author,'PersonId'));
					 
					if(_.includes(authorIds,_.get(cookies.user,'PersonId'))){
						$s.canUpdate = true;
					
					}

					callback();

				});
			};

			
			$s.formatDateString = function(dateTimeString){
				
				var stringDate = null;
				if(!_.isNull(dateTimeString) && !_.isEmpty(dateTimeString)){
					var dateFormat = MSF.getActiveHerdTimeFormatWithLongDigitYear();
					stringDate = moment(dateTimeString).format(dateFormat);
				}
				return stringDate;
			}
			

			$s.getAssociatedMetricsStringList = function getAssociatedMetricsStringList(metricsArray,fieldName,seperator){
				var stringList = "";
				if(_.get(metricsArray,'length') > 0){

					var fieldCodes = _.pluck(metricsArray,fieldName);
					var dispalyValues = _.map( fieldCodes,function(metricCode){
												var displayMetricName = metricCode;
														var metricCodeValue = _.get(_.find($s.codeFile,{codeType: "ACTIONITEMMETRIC",code:metricCode}),'codeValue');
														if(!_.isUndefined(metricCodeValue)){
															displayMetricName = metricCodeValue;
														}
														return displayMetricName;
											});
					if(_.get(dispalyValues,'length') > 0){
						stringList = dispalyValues.join(seperator);
					}
					
				}
			
				return stringList;
			};

			function buildReportData(){

                     
				



				

				$s.actionItemStatuses = _.sortBy(_.filter($s.codeFile,{codeType:"ACTIONSTATUS"}),'dropDownSeq');
			   
				// resultsWriteRptJson data 

				// in the database next evaluation date is stored as a string, the date input control requires a date
				_.set($s.report,'resultsWriteRptJson.formattedHighlights',_.get($s.reportData,'resultsWriteRptJson.formattedHighlights',""));
				_.set($s.report,'resultsWriteRptJson.nextEvaluationDate',_.get($s.reportData,'resultsWriteRptJson.nextEvaluationDate',""));
				
				var resultsWriteRptData = _.get($s.reportData,'resultsWriteRptJson');
				if(!_.isUndefined(resultsWriteRptData)){
					_.set($s.report,'resultsWriteRptJson.formattedHighlights',_.get(resultsWriteRptData,'formattedHighlights',""));
					_.set($s.report,'resultsWriteRptJson.nextEvaluationDate',_.get(resultsWriteRptData,'nextEvaluationDate',""));
					
	
					_.forEach($s.report.resultsWriteRptJson.comments,function(comment,index){
						_.set(comment,'formattedComments',_.get(_.find(_.get(resultsWriteRptData,'comments'),{category: _.get(comment,'category')}),'formattedComments',""));
					});
				}
			      
				setAuthorsDisplay();
				
			

				//_.set($s.report,'reviewDraftRptJson.reportDate',$s.formatDateString(_.get($s.reportData,'reviewDraftRptJson.reportDate',"")));
				_.set($s.report,'reviewDraftRptJson.reportDate',_.get($s.reportData,'reviewDraftRptJson.reportDate',""));
				_.set($s.report,'reviewDraftRptJson.milkingCnt', _.get($s.reportData,'reviewDraftRptJson.milkingCnt'), "");
				_.set($s.report,'reviewDraftRptJson.pregRate',getRateValueByQuestionId($s.pregRateQuestionId));		
				_.set($s.report,'reviewDraftRptJson.concRate',getRateValueByQuestionId($s.concRateQuestionId));

				// action item groups and items
				_.set($s.report,'reviewDraftRptJson.actionItemGroups',_.get($s.reportData,'reviewDraftRptJson.actionItemGroups',[]));
				$s.actionItemGroups =  _.get($s.reportData,'reviewDraftRptJson.actionItemGroups',[]);

				_.forEach($s.actionItemGroups,function(actionItemGroup){
					_.set(actionItemGroup,'AssociatedMetricsDisplay',
						$s.getAssociatedMetricsStringList(_.get(actionItemGroup,'AssociatedMetrics',[]),"Metric",",")
						);
				});

				$s.breadcrumbs = f360Service.getReport360Breadcrumbs($s.formatDateString(_.get($s.report,'reviewDraftRptJson.reportDate')));
				$s.lastBreadcrumbs = $s.breadcrumbs.pop();
				

			}
			function loadCurrentHerd(callback){
				   
				  auditService.getHerdsByFarmId(_.get($s.activeFarm,'farmId'), function getF360HerdsByFarmId(err, herd){
						if (err) {
							console.log('err', err);
						}
							$s.currentHerd =  herd[0];
							var currentHMS = _.get($s.currentHerd,'herdMgmtSoftware');
									   //if the farm doesn't currently have the F360  module on we will want to redirect the user that got here
						
							  if(_.isNull(currentHMS) || _.isUndefined(currentHMS)){
								 MSF.loadPage('Login');
							  }
				
						callback();       
				  });

			   
			}
			function setAuthorsDisplay(){

				auditService.getListByHerdId($s.performanceContext, function getF360ListByHerdId(err, data) {
					var currentAudit = _.find(data,{AuditId: self.auditId},'Name');
                    var authors = MSF.parseJsonStringToArray(_.get(currentAudit,'Authors','{}'),"Failed to parse Authors in setAuthorsDisplay on Review Draft.")
					var authorsDisplay = "";
					if(!_.isUndefined(authors)){
						var authorsFullNames = _.map(authors,(author)=>_.get(author,'FirstName',"") + " " + _.get(author,'LastName',""));
						authorsDisplay = authorsFullNames.join(", ");
					}
					
					$s.authors = authorsDisplay;
					$s.$applyAsync();
				});

			}
			
			function getRateValueByQuestionId(questionId){
				var rateValue = "";
				var answer = _.find($s.auditAnswers,{QuestionId:questionId});

				if(answer){
				   var value = _.get(answer,'AnswerDetailsJson.Value',"");
				   if(!_.isNull(value) && !_.isEqual(value,"")){
					   rateValue = value;
				   } 
				}

                return rateValue;
			} 
			function removeExcludedQuestions(){
				var notApplicableQuestion = _.find($s.auditQuestions, function(question) {
					return _.isEqual(question.SubHeading,"Dry Cows Far-Off") && _.isEqual(question.QuestionTemplate,"TF");
				  
				  });
			 if(!_.isUndefined(notApplicableQuestion)){
				  var notApplicableQuestionAnswer = _.find($s.auditAnswers,"QuestionId",notApplicableQuestion.QuestionId);	
				  if(_.isEqual(_.get(notApplicableQuestionAnswer,'AnswerDetailsJson.Value',constant.answerFalse),constant.answerTrue)){
					  //if the not applicable TF question is true (checked), we first want to exclude any calculated question that is dependent on the questions in the not applicable TF question's subheading
					   var excludedQuestionIds = [];
					   var subHeadingQuestions = _.filter($s.auditQuestions,{SubHeading: notApplicableQuestion.SubHeading});
					   _.forEach(subHeadingQuestions,function(subHeadingQuestion){
						  var calcTags = _.get(subHeadingQuestion,'QuestionDetailsJson.calcTag',null);
						  
						  if(!_.isNull(calcTags)){
							  _.forEach(calcTags,function(calcTag){
								 
								  var calcQuestion = _.find($s.auditQuestions,function(question){ 
													  
														  var calcVarArray = _.get(question,'QuestionDetailsJson.calculations.calculationVars');
														  if(!_.isUndefined(calcVarArray) && !_.isEmpty(calcVarArray)){
																  var valueTagObjects = [];
	
																  _.forEach(calcVarArray,function(calcVarObject){
																	  var calcVarObjectKey = _.keys(calcVarObject)[0];
																	  valueTagObjects.push(calcVarObject[calcVarObjectKey]);
																  });
																  var calcQuestionMatch = false;
																  _.forEach(valueTagObjects,function(valueTagObject){
																	  if(_.isEqual(subHeadingQuestion.SubHeading,valueTagObject.subHeading) && _.includes(valueTagObject.valueTag,calcTag)){
																		  calcQuestionMatch = true;
																		  return false;		
																	  }
	
																  });
	
	
																  return calcQuestionMatch;
														  }
													   
														  
													  });
									 if(!_.isUndefined(calcQuestion) && !_.includes(excludedQuestionIds,calcQuestion.QuestionId)){
										 excludedQuestionIds.push(calcQuestion.QuestionId);
									 }	
							  });
						  }
						  
					   });
	
					  
					  // then  we want to exclude the questions in that subheading for the counts on the overview screen
					  $s.auditQuestions = _.reject($s.auditQuestions,function(question){ return _.isEqual(question.SubHeading,notApplicableQuestion.SubHeading) || _.includes(excludedQuestionIds,question.QuestionId);});
	
					 
					 
				  }else{
					  //even if the not applicable question is false, we still don't want to include it in the answer count
					  $s.auditQuestions = _.reject($s.auditQuestions,function(question){ return _.isEqual(question.QuestionId,notApplicableQuestion.QuestionId);});
				  }	   
			 }
			}
			function loadPieCharts(){
				//all data for pie charts are for questions that have an industry guideline
				
				// overall summary pie chart 
				_.set($s.overallSummaryPieChart,'title',"Questions that Met Industry Guideline");
				

				var overallSummaryQuestionData = [
					{name: "Met Guideline", data: _.filter($s.allMetGuidelineQuestionsWithGuidelines,function(question){ return !_.isEqual(_.get(question,'Category'),"INFORM");}).length},
					{name: "Did Not Meet Guideline", data: _.filter($s.allOutsideGuidelineQuestionsWithGuidelines,function(question){return _.isEqual(_.get(question,'Answer.IsOptedOut'),false) &&  !_.isEqual(_.get(question,'Category'),"INFORM");}).length},
					{name: "Not Answered", data: _.filter($s.allOutsideGuidelineQuestionsWithGuidelines,function(question){return _.isEqual(_.get(question,'Answer.IsOptedOut'),true) &&  !_.isEqual(_.get(question,'Category'),"INFORM");}).length}
				];
				_.set($s.overallSummaryPieChart,'seriesData',overallSummaryQuestionData);

				var overallPieChartCanvasElement = document.getElementById("overallSummaryPieChart");// $('#overallSummaryPieChart')[0];
				var overallPieChartElement = overallPieChartCanvasElement.getContext('2d');
				
				var overallPieChartOptions = {
					title:{
						fontSize: 14
					},
					legend:{
						labels:{
							boxWidth: 15
						},
						position: "bottom"
					},
					tooltips:{
						enabled: false
					}
				};
				
				
			$s.overallSummaryPieChart.chart = ChartService.getCircleChart(overallPieChartElement, overallPieChartOptions,$s.overallSummaryPieChart.seriesData, $s.overallSummaryPieChart.title);

			var filteredStructuredQuestionsAndAnswers = _.filter($s.structuredQuestionsAndAnswers,function(question){ return !_.isEqual(_.get(question,'Category'),"INFORM");});
				_.forEach(filteredStructuredQuestionsAndAnswers,function(category){

				// if this category shouldn't show a chart , skip to the next category
				if(!_.get(category,'showInPieChart')){
					return;
			    }
					 					
				var categoryChart = {
					chart: {},
					title: "",
					seriesData: [] 
				};
				_.set(categoryChart,'title',category.categoryDisplay+" Questions that Met Industry Guideline");

				var allMetGuidelineQuestions = _.flattenDeep(_.pluck(category.subtitles,'metGuidelineQuestions'));
				var outsideGuidelineQuestions =  _.flattenDeep(_.pluck(category.subtitles,'outsideGuidelineQuestions'));

				var allMetGuidelineQuestionsWithGuidelines = _.filter(allMetGuidelineQuestions,function(question){ 
					return !_.isUndefined(_.get(question,'QuestionDetailsJson.industryGuideline.compare'));
			    }); 
				var allOutsideGuidelineQuestionsWithGuidelines = _.filter(outsideGuidelineQuestions,function(question){ 
							return !_.isUndefined(_.get(question,'QuestionDetailsJson.industryGuideline.compare')) 
									&& _.isEqual(_.get(question,'Answer.IsOptedOut'),false);
						});         
				var allNotAnsweredQuestions = _.filter(outsideGuidelineQuestions,function(question){ 
				return !_.isUndefined(_.get(question,'QuestionDetailsJson.industryGuideline.compare')) 
					&& _.isEqual(_.get(question,'Answer.IsOptedOut'),true);
				});         

				var seriesData = [
					{name: "Met Guideline", data: allMetGuidelineQuestionsWithGuidelines.length},
					{name: "Did Not Meet Guideline", data: allOutsideGuidelineQuestionsWithGuidelines.length},
					{name: "Not Answered", data: allNotAnsweredQuestions.length}

				];
				_.set(categoryChart,'seriesData',seriesData);
				
				var categoryPieChartCanvasElement = document.getElementById("circle-chart-"+category.categoryCode);
				var categoryPieChartElement = categoryPieChartCanvasElement.getContext('2d');
				
				var categoryPieChartOptions = {
					legend:{
						labels:{
							boxWidth: 15
						},
						position: "bottom"
					},
					tooltips:{
						enabled: false
					}
				};
				
				
				var chart = ChartService.getCircleChart(categoryPieChartElement, categoryPieChartOptions,categoryChart.seriesData, categoryChart.title);
				_.set(categoryChart,'chart',chart);
				$s.categoryPieCharts.push(categoryChart);
				

			});
						
			}

			function loadBarCharts(){
				
					  
			   // Question Category Chart

			   _.set($s.categoryBarChart,'title',["Questions that Met Industry Guideline by Category"]);
			 

			   var metGuidelineQuestionsSeriesDataByCategory = [];
			   var outsideGuidelineQuestionsSeriesDataByCategory = [];
			   var optedQuestionsSeriesDataByCategory = [];


			   var allMetGuidelineQuestionsWithGuidelines = _.filter($s.allMetGuidelineQuestions,function(question){ return !_.isUndefined(_.get(question,'QuestionDetailsJson.industryGuideline.compare')) && !_.isEqual(_.get(question,'Category'),"INFORM");});
			   var allOutsideGuidelineQuestionsWithGuidelines = _.filter($s.allOutsideGuidelineQuestions,function(question){ return !_.isUndefined(_.get(question,'QuestionDetailsJson.industryGuideline.compare')) && !_.isEqual(_.get(question,'Category'),"INFORM");});         
		 
			 
			   var filteredCodeFileQuestionCategories = _.filter($s.codeFileQuestionCategories,function(category){return !_.isEqual(_.get(category,'code'),"INFORM"); } );
			   _.forEach(filteredCodeFileQuestionCategories,function(codeFileCategory){
				
					 
				var metGuidelineQuestionsByCategory = _.filter(allMetGuidelineQuestionsWithGuidelines,{Category: _.get(codeFileCategory,'code')});
				metGuidelineQuestionsSeriesDataByCategory.push(metGuidelineQuestionsByCategory.length);

				var outsideGuidelineQuestionsByCategory = _.filter(allOutsideGuidelineQuestionsWithGuidelines,{Category: _.get(codeFileCategory,'code'),Answer : {IsOptedOut: false}});
				outsideGuidelineQuestionsSeriesDataByCategory.push(outsideGuidelineQuestionsByCategory.length);

				var optedQuestionsByCategory = _.filter(allOutsideGuidelineQuestionsWithGuidelines,{Category: _.get(codeFileCategory,'code'),Answer : {IsOptedOut: true}});
				optedQuestionsSeriesDataByCategory.push(optedQuestionsByCategory.length);
					 
			 });

			 var categoryBarChartData = {
				categoryLabels: _.map(filteredCodeFileQuestionCategories,function(codeFileCategory){ return _.get(codeFileCategory,'codeValue');}),
			  seriesData : []

			 };
			   
				
			 categoryBarChartData.seriesData.push( {
				label: "Met Guideline",
				data: metGuidelineQuestionsSeriesDataByCategory,
				backgroundColor: _.times(metGuidelineQuestionsSeriesDataByCategory.length,_.constant("#5C93B4")),
				borderColor: _.times(metGuidelineQuestionsSeriesDataByCategory.length,_.constant("#5C93B4")),
				borderWidth: _.times(metGuidelineQuestionsSeriesDataByCategory.length,_.constant(1)),
				hoverBackgroundColor: _.times(metGuidelineQuestionsSeriesDataByCategory.length,_.constant("#3478A2")),
				hoverBorderColor: _.times(metGuidelineQuestionsSeriesDataByCategory.length,_.constant("#3478A2")),
		   },{
			   label: "Did Not Meet Guideline",
			   data: outsideGuidelineQuestionsSeriesDataByCategory,
			   backgroundColor: _.times(outsideGuidelineQuestionsSeriesDataByCategory.length,_.constant("#EF8666")),
			   borderColor: _.times(outsideGuidelineQuestionsSeriesDataByCategory.length,_.constant("#EF8666")),
			   borderWidth: _.times(outsideGuidelineQuestionsSeriesDataByCategory.length,_.constant(1)),
			   hoverBackgroundColor: _.times(outsideGuidelineQuestionsSeriesDataByCategory.length,_.constant("#EB6841")),
			   hoverBorderColor: _.times(outsideGuidelineQuestionsSeriesDataByCategory.length,_.constant("#EB6841")),
		   },{
			label: "Not Answered",
			data: optedQuestionsSeriesDataByCategory,
			backgroundColor: _.times(optedQuestionsSeriesDataByCategory.length,_.constant("#ededed")),
			borderColor: _.times(optedQuestionsSeriesDataByCategory.length,_.constant("#ededed")),
			borderWidth: _.times(optedQuestionsSeriesDataByCategory.length,_.constant(1)),
			hoverBackgroundColor: _.times(optedQuestionsSeriesDataByCategory.length,_.constant("#d9d9d9")),
			hoverBorderColor: _.times(optedQuestionsSeriesDataByCategory.length,_.constant("#d9d9d9")),
		});

		   _.set($s.categoryBarChart,'seriesData',categoryBarChartData);

		  var categoryStepSize = 5;

		   var categoryBarChartOptions = {
			   title: {
				   display: true,
				   fontSize: 14
			   },
			   legend:{
				   labels:{
					   boxWidth: 15
				   },
				   position: "bottom"
				   
			   },
			   scales: {
				 xAxes: [{
					stacked: false,
					categoryPercentage: 1.0,
					barPercentage: 0.75,
					ticks: {
						autoSkip: false,
						suggestedMax: 40
					}
					 }]
			   },
			   tooltips:{
				   enabled: false
			   }
		   };

		  var categoryBarChartCanvasElement = document.getElementById("categoryBarChart");
		  var categoryBarChartElement = categoryBarChartCanvasElement.getContext('2d');
		  $s.categoryBarChart.chart  =  ChartService.getBarChart(categoryBarChartElement,categoryBarChartOptions, $s.categoryBarChart.seriesData, $s.categoryBarChart.title, categoryStepSize);
		

			}

			function loadReportCharts(){
				var sectionChartCanvasJQOs = $('[id^="circle-chart-"]');

				if(sectionChartCanvasJQOs.length > 0){
					loadPieCharts();
					loadBarCharts();
				}else{
					var deregSectionChartCanvasInterval = $interval(function()
					{
						sectionChartCanvasJQOs = $('[id^="circle-chart-"]');
						var sectionChartCanvasExists = sectionChartCanvasJQOs.length > 0;
						
						if(sectionChartCanvasExists){
							loadPieCharts();
							loadBarCharts();
							$interval.cancel(deregSectionChartCanvasInterval);
						}
						
					},100);
				}
			}

			function buildStructuredQuestionsAndAnswers(){
				
				_.forEach($s.codeFileQuestionCategories,function(codeFileQuestionCategory){
					var categoryCode = _.get(codeFileQuestionCategory,'code');
					var structuredQuestionsAndAnswersItem = {
						categoryCode: categoryCode,
						categoryDisplay: _.get(codeFileQuestionCategory,'codeValue'),
						categoryOrder: _.get(_.find($s.codeFileQuestionOrders,{code: categoryCode}),'dropDownSeq'),
						showInPieChart: _.get(codeFileQuestionCategory,'detailsJson[0].showInPieChart')
					};
	
					
					var subCategoriesOfCategory = _.filter($s.codeFileQuestionSubCategories,{categoryCode: categoryCode});
					
					// subcategories 
					var structuredSubCategories = [] ;
					_.forEach(subCategoriesOfCategory,function(codeFileSubCategory){
						var categoryCode = _.get(codeFileSubCategory,'categoryCode');
	
						_.forEach(_.get(codeFileSubCategory,'subCategories'),function(subCategory){
	
						
							var structuredSubCategory = {
								categoryCode: categoryCode,
								subCategoryKey: _.get(subCategory,'key'),
								subCategoryKeyDisplay: _.get(subCategory,'description'),
								subCategoryOrder: _.get(subCategory,'Order'),
								metGuidelineQuestions: [],
								outsideGuidelineQuestions: []
	
							};
	
							   var subCategoryQuestions = _.filter($s.auditQuestionsWithAnswers,{Category: categoryCode ,SubCategory: _.get(subCategory,'key')});
							   var subCateogryMetGuidelineQuestions = _.filter(subCategoryQuestions,function(question){
																		   var metGuideLines = _.get(question,'Answer.MetGuideline');
																		   if(!_.isUndefined(metGuideLines)){
																			   if(metGuideLines){
																				   return question;
																			   }
																		   }
																	  });
							   var subCateogryOutsideGuidelineQuestions =  _.filter(subCategoryQuestions,function(question){
																					var metGuideLines = _.get(question,'Answer.MetGuideline');
																					if(!_.isUndefined(metGuideLines)){
																						if(!metGuideLines){
																							return question;
																						}
																					}
																			});
							  _.set(structuredSubCategory,'metGuidelineQuestions',subCateogryMetGuidelineQuestions);
							  _.set(structuredSubCategory,'outsideGuidelineQuestions',subCateogryOutsideGuidelineQuestions);												
	
							
							structuredSubCategories.push(structuredSubCategory);
						});
						
					});	
	
					 structuredSubCategories = _.sortByOrder(structuredSubCategories,["subCategoryOrder"],["asc"]); 
					_.set(structuredQuestionsAndAnswersItem,'subCategories',structuredSubCategories);
					   
	
	
					// subtitles
					var codeFileSubtitlesOfCategory = _.filter($s.codeFileQuestionSubtitles,{orderCode: categoryCode});
	
					var structuredSubTitles = [] ;
					_.forEach(codeFileSubtitlesOfCategory,function(codeFileSubtitle){
						var categoryCode = _.get(codeFileSubtitle,'orderCode');
	
						_.forEach(_.get(codeFileSubtitle,'subtitles'),function(subtitle){
	
						
							var structuredSubtitle = {
								categoryCode: categoryCode,
								subtitleKey: _.get(subtitle,'key'),
								subtitleKeyDisplay: _.get(subtitle,'description'),
								subtitleOrder: _.get(subtitle,'Order'),
								metGuidelineQuestions: [],
								outsideGuidelineQuestions: []
							};
							//,SubCategory: categoryCode
							var subtitleQuestions = _.filter($s.auditQuestionsWithAnswers,{Category: categoryCode ,Subtitle: _.get(subtitle,'key')});
							var subtitleMetGuidelineQuestions = _.filter(subtitleQuestions,function(question){
																		var metGuideLines = _.get(question,'Answer.MetGuideline');
																		if(!_.isUndefined(metGuideLines)){
																			if(metGuideLines){
																				return question;
																			}
																		}
																   });
							var subtitleOutsideGuidelineQuestions =  _.filter(subtitleQuestions,function(question){
																				 var metGuideLines = _.get(question,'Answer.MetGuideline');
																				 if(!_.isUndefined(metGuideLines)){
																					 if(!metGuideLines){
																						 return question;
																					 }
																				 }
																		 });
						   _.set(structuredSubtitle,'metGuidelineQuestions',subtitleMetGuidelineQuestions);
						   _.set(structuredSubtitle,'outsideGuidelineQuestions',subtitleOutsideGuidelineQuestions);	
	
						   $s.allMetGuidelineQuestions = _.union( $s.allMetGuidelineQuestions,subtitleMetGuidelineQuestions);
						   $s.allOutsideGuidelineQuestions = _.union( $s.allOutsideGuidelineQuestions,subtitleOutsideGuidelineQuestions);
							
							structuredSubTitles.push(structuredSubtitle);
						});
						
					});	
					structuredSubTitles = _.sortByOrder(structuredSubTitles,["subtitleOrder"],["asc"]); 
					_.set(structuredQuestionsAndAnswersItem,'subtitles',structuredSubTitles);
	
					$s.structuredQuestionsAndAnswers.push(structuredQuestionsAndAnswersItem);
	
			  });
	
			  $s.structuredQuestionsAndAnswers = _.sortByOrder($s.structuredQuestionsAndAnswers,["categoryOrder"],["asc"]);
	
			  $s.allMetGuidelineQuestionsWithGuidelines = _.filter($s.allMetGuidelineQuestions,function(question){ return !_.isUndefined(_.get(question,'QuestionDetailsJson.industryGuideline.compare'));}); 
			  $s.allOutsideGuidelineQuestionsWithGuidelines = _.filter($s.allOutsideGuidelineQuestions,function(question){ return !_.isUndefined(_.get(question,'QuestionDetailsJson.industryGuideline.compare'));});
			  $s.orderedQuestionsAndAnswers = _.union($s.allOutsideGuidelineQuestions,$s.allMetGuidelineQuestions);
			
			}
	
			// function that loads the action items on load of the results and write report screen
			function loadActionItems(){
				
				_.forEach($s.sectionsQuestionsAndAnswers,function(section){
					 
					 _.forEach(section.outsideGuidelineQuestions,function(question){
						 if(_.get(question,'Answer.ActionItem')){
							 $s.actionItems.push(question);
						 }
					 });
	
	
					 _.forEach(section.metGuidelineQuestions,function(question){
						if(_.get(question,'Answer.ActionItem')){
							$s.actionItems.push(question);
						}
					});
	
	
				});
				
			}

			// function that loads the followup items on load of the results and write report screen
			function loadFollowupItems(){
				
				var allQuestions = _.flattenDeep(
					_.map( _.pluck($s.structuredQuestionsAndAnswers,'subtitles'),function(subtitlesOfCategory){
						  var questions =  _.union(_.flattenDeep(_.pluck(subtitlesOfCategory,'metGuidelineQuestions')),_.flattenDeep(_.pluck(subtitlesOfCategory,'outsideGuidelineQuestions')));
						  return questions;
					})
				);

                $s.followupItems = _.filter(allQuestions,{Answer: {FollowUp: true}});
				
			}

		

			$s.printReport = function printReport(){
				$window.print();
			};

			$s.onActionItemStatusChange = function onActionItemStatusChange(question){
				var auditAnswer = _.find($s.auditAnswers,{"QuestionId":question.QuestionId});
					auditAnswer.AnswerDetailsJson = angular.copy(question.Answer); 

					// we need to convert answer date fields to a string format before saving. 
					_.set(auditAnswer,'AnswerDetailsJson.TargetDate',$s.formatDateString(_.get(question,'Answer.TargetDate',null))); 

					$s.updateAnswers();	
			};
			

			$s.updateAnswers = function updateAnswers(){
				if($s.syncInProgress === false && $s.updateInProgress === false){
					$s.syncInProgress = true;	
					$s.checkF360SyncStatus().then(function(){
						$s.updateInProgress === true;
						log.info("updateAnswer: start");

						
			
						var AnswerJson = JSON.stringify($s.auditAnswers);

						$s.isDirty = true;
						auditService.updateAnswer(auditId, AnswerJson, function getF360Update (err, data) {
							if (err) {
								log.error('error getting F360 online check: ' + err);
								$s.isDirty = false;
							}else{
							$s.updateInProgress = false;
							if($s.finalSaveRequired === true){
								log.info("one more save is required 736");
								$s.finalSaveRequired = false;
								$s.updateAnswers();
							}
							log.info("answerUpdate: update of answer failed, update end");
							
							// if the update was successfull and we are online we can then the data was synced and we can set isDirty false
							if($s.isOnline){

													
								$s.isDirty = false;
								auditService.updateIsDirty(auditId,$s.isDirty,function getIsDirtyUpdate(err, data){
									if (err) {
										log.error('error updateing isDirty flag: ' + err);
									}
							
									auditService.getListByHerdId($s.performanceContext, function getF360ListByHerdId(err, data) {
									var auditlistItem = _.find(data,{AuditId: auditId});

									log.info("answerUpdate: updating last synced date with : ");
									log.info(auditlistItem);

									//if the audit was deleted ,the record won't be in IndexedDB and doesn't need SyncedOn updated
									if(!_.isUndefined(auditlistItem)){ 
										auditService.updateLastSyncedDate(auditId,_.get(auditlistItem,'SyncedOn'),function getUpdateLastSyncDateData(err,data){
											if (err) {
												log.error('error updating server with device data: ' + err);
											}
											
											$s.updateInProgress = false;
											if($s.finalSaveRequired === true){
												log.info("one more save is required 767");
												$s.finalSaveRequired = false;
												$s.updateAnswers();
											}
											log.info("answerUpdate: udpated audit sync date after answer update, update end");
										});	 
									}else{
										log.info("answerUpdate: could not find audit indexedDB, update end");
										$s.updateInProgress = false;
										if($s.finalSaveRequired === true){
											log.info("one more save is required 777");
											$s.finalSaveRequired = false;
											$s.updateAnswers();
									    }
									
									}

								});
							});
							}else{
								auditService.updateIsDirty(auditId,$s.isDirty,function getIsDirtyUpdate(err, data){
									if (err) {
										log.error('error updateing isDirty flag: ' + err);
									}
									$s.updateInProgress = false;
									if($s.finalSaveRequired === true){
										log.info("one more save is required 793");
										$s.finalSaveRequired = false;
										$s.updateAnswers();
									}
									log.info("answerUpdate: offline and updated is dirty flag, update end");
								});
							}
								
								
								//console.log('update ok');
						}
						});
					});
				}else{
					log.info("an answer save attempt was made while another one was going");
					$s.finalSaveRequired = true;
					
				}
				
			};
			//function that constructs the display value of a given text value  
			$s.getTextDisplayValue  = function getTextDisplayValue(text){

				// replace any measurement standard text 
				var activeFarmMeasurementStandard = _.get($s.activeFarm,'measurementStandard',"");

				text = MSF.getMeasurementStandardReplacementText(activeFarmMeasurementStandard,text);

				return text;

			};
			// function that formats a questions answer value and returns the formatted value
			$s.formatAnswer = function(question){
			
				var formattedAnswerValue = "";
	
				var questionTemplate = _.get(question,'QuestionTemplate',"");
				var answerValue = _.get(question,'Answer.Value',"");
				var codeType = _.get(question,'CodeType',"");
	
				switch(questionTemplate){
					case "%3,0":
					case "%5,1":
						if(_.isEqual(_.get(question,'Answer.IsOptedOut'),false)){
							formattedAnswerValue = answerValue + '%';
						}else{
							formattedAnswerValue = answerValue;
						}
					break;
					case "SINGL":
						formattedAnswerValue = _.get(_.find($s.codeFile,{codeType: codeType,code: answerValue}),'codeValue',answerValue); 
					break;
					case "YN":
					   if(answerValue === "Y"){
						   formattedAnswerValue = "Yes";
					   }else if(answerValue === "N"){
						   formattedAnswerValue = "No";
					   } 
					break;
					case "MULTI":
						var valueList = answerValue;
						valueList = valueList.replace(/["()']/g,""); 
						//then we create an array to compare value to 							
						var values = valueList;
						values = valueList.split(',');
						// if the code type for the question was MONTH we need to order the values by calendar order
						if(_.isEqual(question.CodeType,"MONTH")){
						
						 var months = _.filter($s.codeFile,{codeType:"MONTH"});
		
						 values = _.sortBy(values, x => _.findIndex(months, y => _.isEqual(x,y.code))); 
						}
	
						// the values we want to dispaly in the grid is the codeValue(s)(button label) of the code(s)(answer choice) chosen. 
						values = _.map(values,function(value){
						
							var displayValue = _.get(_.find($s.codeFile,{code: value}),'codeValue',value);
							
							
							return displayValue; 
						});
						values = values.join(', ');
	
	
						formattedAnswerValue = values;
		
					break;
					default:
					  formattedAnswerValue = answerValue;
	
				}
				return formattedAnswerValue;
			};
			$s.formatIndustryGuideline = function(guideline){
	  
				 var formattedGuideline = "";
				switch(guideline){
					case "---":
					case undefined:{
						formattedGuideline = "N/A";
					break;
					}
					default:
						formattedGuideline = guideline;
					break;	
				}
				return formattedGuideline;
			};
			$s.validateTargetDate = function(question){
				var validTargetDate = false;
                  if(_.isEqual(_.get(question,'Answer.MgmtAccepted'),true)){
					  var targetDate = _.get(question,'Answer.TargetDate',null);
					   // the target date is required if MgmtAccepted is true and cannot be in the past
					  if((!_.isNull(targetDate)) && (targetDate >= $s.minTargetDate)){
						  validTargetDate = true;
					  }
					
				  }else{
					validTargetDate = true;
				  }

                  if(validTargetDate === false){
					$("#target-date-label-"+question.QuestionId).addClass('text-red');
					$("#target-date-container-"+question.QuestionId).addClass('error-container');
					$("#errorInputvalidateTargetDate-"+question.QuestionId).removeClass('dis-none');
				}else{
					$("#target-date-label-"+question.QuestionId).removeClass('text-red');
					$("#target-date-container-"+question.QuestionId).removeClass('error-container');
					$("#errorInputvalidateTargetDate-"+question.QuestionId).addClass('dis-none');
					var auditAnswer = _.find($s.auditAnswers,{"QuestionId":question.QuestionId});
						auditAnswer.AnswerDetailsJson = angular.copy(question.Answer); 

						// we need to convert answer date fields to a string format before saving. 
						_.set(auditAnswer,'AnswerDetailsJson.TargetDate',$s.formatDateString(_.get(question,'Answer.TargetDate',null))); 

					$s.updateAnswers();	
				}


				return validTargetDate;
			};

			

			$s.addQuestionCategories = function(){
				//test interval 22
				var firstIntervalStartIndex = 2;
				var secondIntervalStartIndex = 25;
				var thirdIntervalStartIndex = 48;
				var fourthIntervalStartIndex = 71;
				var fifthIntervalStartIndex = 94;
				var sixthIntervalStartIndex = 117;
	
				_.forEach($s.auditQuestions,function(question){
					switch(true){
						case  (question.QuestionId >= 2 && question.QuestionId < 25):
						  _.set(question,'category','Cow Comfort');
						break;
						case (question.QuestionId >= 25 && question.QuestionId < 48):
							_.set(question,'category','Data Quality');
							break;
						case (question.QuestionId >= 48 && question.QuestionId < 71):
							_.set(question,'category','Fertility');
							break;
						case (question.QuestionId >= 71 && question.QuestionId < 94):
							_.set(question,'category','Nutrition');
							break;		
						case (question.QuestionId >= 94 && question.QuestionId < 117):
							_.set(question,'category','Personnel');
							break;
						case (question.QuestionId >= 117 && question.QuestionId < 140):
							_.set(question,'category','Transition Cow');
							break;
						case (question.QuestionId >= 141):
							_.set(question,'category','Unassigned');
							break;		
	
					}
				});
				
			};

			
		function orderAdditionalComments(){
			var orderedComments = [];
			var comments = _.get($s.report,'resultsWriteRptJson.comments',[]);
			var orderedCodeFileQuestionOrders = _.sortByOrder(_.cloneDeep($s.codeFileQuestionOrders),["dropDownSeq"],["asc"]);
			 _.forEach(orderedCodeFileQuestionOrders,function(codeFileOrderItem){
                   var commentObj = _.find(comments,{category: _.get(codeFileOrderItem,'code')});
				   if(!_.isUndefined(commentObj)){
					   orderedComments.push(commentObj);
				   }
			});

			if(!_.isEmpty(orderedComments)){
				_.set($s.report,'resultsWriteRptJson.comments',orderedComments);
			}
		} 


		function loadReportData(){
			const loadReportDataPromise = $q.defer();	

			perfMetricSvc.startTiming("Page:F360PublishedReportGetListByHerdId:Request");
			auditService.getListByHerdId($s.performanceContext, function(err, auditListData){
				perfMetricSvc.endTiming("page","Page:F360PublishedReportGetListByHerdId:Request", $s.performanceContext);
		
				$s.auditApiVersion = "v2.0";


				perfMetricSvc.startTiming("Page:F360PublishedReportGetListByHerdId:Response");
				auditService.getIndexedDBReviewResultsAndDraft(self.auditId, $s.performanceContext, function getIndexedDBReviewResultsAndDraft(err, data) {
					perfMetricSvc.endTiming("page","Page:F360PublishedReportGetListByHerdId:Response", $s.performanceContext);
					if (err) {
						log.error('error getting F360 Review Results And Draft Data: ' + err);
						MSF.confirmation.danger(err,false);
					}
		
					if (data && data.length) {
						try{
						$s.reportData =	JSON.parse(data);
						}catch(e){
							console.log("failed to parse report date");
						}
		
						if (!window.navigator.onLine) {
							$s.$apply();
						}
					}

						perfMetricSvc.startTiming("Page:F360PublishedReportGetIndexedDBOverViewList:Request");
						auditService.getIndexedDBOverViewList(self.auditId, $s.performanceContext, function getIndexedDBOverViewList(err, data) {
							perfMetricSvc.endTiming("page","Page:F360PublishedReportGetIndexedDBOverViewList:Request", $s.performanceContext);
							if (err) {
								log.error('error getting F360 Over View List: ' + err);
								MSF.confirmation.danger(err,false);
								
							}
							if (data && data.length) {
								$s.overViewList = data;
								for (let index = 0; index < $s.overViewList.length; index++) {
									$s.overViewList[index].AnswerCnt = 0;
									$s.overViewList[index].QuestionCnt = 0;
								}
								if (!window.navigator.onLine) {
									$s.$apply();
								}
							}
							
							perfMetricSvc.startTiming("Page:F360PublishedReportGetIndexedDBQuestionList:Request");
								auditService.getIndexedDBQuestionList(self.auditId, $s.performanceContext, function getIndexedDBQuestionList(err, data) {
									perfMetricSvc.endTiming("page","Page:F360PublishedReportGetIndexedDBQuestionList:Request", $s.performanceContext);
								if (err) {
									log.error('error getting F360 Over View List: ' + err);
									MSF.confirmation.danger(err,false);
								}
								
								if (data && data.length) {
									var arrQuestion = [];
									var parseDataQuestion = JSON.parse(data);
									var questionDetailsJson = parseDataQuestion.QuestionsJson;
								
									for (let i = 0; i < questionDetailsJson.length; i++) {
										arrQuestion.push(questionDetailsJson[i].QuestionJson[0]);
									}
									// we need to order the questions here in the ux because the questions come from a JSON field
									// intead their own records in a table.
									$s.auditQuestions = _.sortByOrder(_.reject(arrQuestion,function(question){ return _.includes(["BODYSCORES","LAMESCORES"],_.get(question,'Section'));}),['SortOrder'],['asc']);


									//TODO remove this function and this line of code once questions are properly updated with categories
								
									
									perfMetricSvc.startTiming("Page:F360PublishedReportGetIndexedDBAnswerList:Request");		
									auditService.getIndexedDBAnswerList(self.auditId, $s.performanceContext, function getIndexedDBAnswerList(err, data) {
										perfMetricSvc.endTiming("page","Page:F360PublishedReportGetIndexedDBAnswerList:Request", $s.performanceContext);
										if (err) {
											console.log('error getting F360 Over View List: ' + err);
											MSF.confirmation.danger(err,false);
										}
										if (data && data.length) {
											try{
											$s.auditAnswers = JSON.parse(data);
											}catch(e){
											log.error("failed to parse answer list json : "+_.get(e,'message'," "));
											}
										
										
										} else {
											$s.auditAnswers = [];
										}

										//if the not applicable question is checked we have to exclude certain questions including the NA question itself. 
										removeExcludedQuestions();

										_.forEach($s.auditQuestions,function(question,index){
												var answer = _.get(_.find($s.auditAnswers,{QuestionId: question.QuestionId}),'AnswerDetailsJson');
												if(!_.isUndefined(answer)){
													var questionWithAnswer = _.cloneDeep(question);
													_.set(questionWithAnswer,'Answer',_.cloneDeep(answer));
													$s.auditQuestionsWithAnswers.push(questionWithAnswer);
												}else{
													console.error(`question with id of ${question.QuestionId} was missing its answer in loadReportData with an index value of ${index} in $s.auditQuestions `);
												}
										});
										perfMetricSvc.startTiming("Page:F360PublishedReport:Build");
										buildStructuredQuestionsAndAnswers();		
										loadFollowupItems();
										 
										
										buildReportData();
										loadReportCharts();
										orderAdditionalComments();
										perfMetricSvc.endTiming("page","Page:F360PublishedReport:Build", $s.performanceContext);
										loadReportDataPromise.resolve();
									
									});
		
								} else {
									loadReportDataPromise.resolve();
									$window.location.href = '#/f360';
								}
							});
						});
					});
				});
				return loadReportDataPromise.promise;
			}

           
			

	
			$s.syncingBackOnline = false;
		   
			deregOnlineCheckWatch =	$s.$on('online:change',function(event,onLineChange){
			 
					var onLineValue = _.get(onLineChange,'value');
					var isOnlineOldValue =  angular.copy($s.isOnline);
					$s.isOnline = onLineValue; 
					// if the device was previously offline and now back online
				 // we need to see if we will run checkF360SyncStatus
				 if(isOnlineOldValue === false && onLineValue === true){
					  if($s.syncingBackOnline === false){
						  $s.syncingBackOnline = true;
						  $s.syncInProgress = true;
						  $s.checkF360SyncStatus().then(function(){
							 $s.syncingBackOnline = false;
							 $s.syncInProgress = false;
						
						  });
					  } 
				 }
				 
			 });

			 $s.checkF360SyncStatus = function checkF360SyncStatus() {
				var syncStatusPromise = $q.defer();
				if ($s.isOnline && $s.updateInProgress === false) {

					
					log.info("checkSync: Synch in Progress");

					auditService.getIndexDBListByHerdId(function getF360List(err, data){

						if(err){
							log.error("There was err in getting cached list : "+err);
							syncStatusPromise.reject(true);
							MSF.loadPage('Fertility360report');
						}
						var activeAuditListData = _.find(data,{AuditId: self.auditId});
						var lastSyncedDate = _.get(activeAuditListData,'SyncedOn',null);
						if(_.isEqual(lastSyncedDate,"")){
							lastSyncedDate = null;
						}
							
					   var  isDeviceDirty = _.get(activeAuditListData,'IsDeviceDirty',false);
					   
					     //if the check sync is in progress, but an update answer/notes occurs , we need to cancel this interval of check sync
						 if(	$s.updateInProgress === true){
							log.info("Section Page : a save has started before calling getSyncedSatus canceling this interval of check sync");
							syncStatusPromise.reject(true);
							   return;
						   }

					   log.info("check Sync: calling getSyncStatus with lastSyncedDate: "+lastSyncedDate+" and isDeviceDirty: "+isDeviceDirty);
					   perfMetricSvc.startTiming("Page:F360PublishedReport:GetSyncStatus:Request");
					   api.getSyncStatus(self.auditId,lastSyncedDate,isDeviceDirty, $s.performanceContext, function getF360SyncStatus(err, data) {
								perfMetricSvc.endTiming("page","Page:F360PublishedReport:GetSyncStatus:Request", $s.performanceContext);
								if (err) {
									self.isSync = false;
									log.error('error getting F360 online check: ' + err);
								}

								  //if the check sync is in progress, but an update answer/notes occurs , we need to cancel this interval of check sync
								  if(	$s.updateInProgress === true){
									log.info("Section Page : a save has started after calling getSyncedSatus canceling this interval of check sync");
									syncStatusPromise.reject(true);
									   return;
								   }
								
								if (data) {
									self.isSync = true;
								
									var syncData = data;	

									if(!_.isUndefined(syncData)){
										log.info("checkedSync: synce data returned with");
										log.info(syncData);
										if((_.isEqual(_.get(syncData,'ToUpdateServer'),true)) || (_.isEqual(_.get(syncData,'ToUpdateServer').toLowerCase(),"true"))){

											log.info("checkedSync: server needed updating");
											auditService.updateServerAuditData(self.auditId,function(err,data){
												if (err) {
													log.error('error updating server with device data: ' + err);
													$s.isDirty = true;
												}else{
													$s.isDirty = false;
												}
												log.info("update server complete");
												// we need to update the IsDeviceDirty flag of the audit in IndexDB
												auditService.updateIsDirty(self.auditId,$s.isDirty,function getIsDirtyUpdate(err, data){
													if (err) {
														log.error('error updateing isDirty flag: ' + err);
													}
													log.info("checkedSync: update IsDeviceDirty complete");
													// we need to call up the database version of SyncedOn because the update server proccess sets a more current SyncedOn on the server side
													auditService.getListByHerdId($s.performanceContext, function getF360ListByHerdId(err, data) {
														var auditlistItem = _.find(data,{AuditId: self.auditId});
	
														log.info("checkedSync: updating last synced date with : ");
														log.info(auditlistItem);
	
														 //if the audit was deleted ,the record won't be in IndexedDB and doesn't need SyncedOn updated
														if(!_.isUndefined(auditlistItem)){ 
															auditService.updateLastSyncedDate(self.auditId,_.get(auditlistItem,'SyncedOn'),function getUpdateLastSyncDateData(err,data){
																if (err) {
																	log.error('error updating server with device data: ' + err);
																}
																
																log.info("checkedSync: last synced date update complete , sync end");
																syncStatusPromise.resolve(true);
																
			
															});	 
														}else{
															log.info("checkedSync: audit was deleted . so no need to update last synced date. sync end ");
															syncStatusPromise.resolve(true);
														}
		
													});
												});
												
												
	
											});
										}else{
										   // the device's SyncedOn Date is older than the server's copy of the same property and the device needs updating
											log.info("checkSync: server is up to date , need to check if device needs updating");
												if((_.isEqual(_.get(syncData,'ToUpdateDevice'),true)) || (_.isEqual(_.get(syncData,'ToUpdateDevice').toLowerCase(),"true"))){
													log.info("checkSync: device needs updating , setting device update flag true , sync end");
												
													 // if the device needs updating then we need to send the user back to the f360 dashboard to attempt a device sync after prompt
													 syncStatusPromise.reject(true);
													MSF.loadPage('Fertility360report');
												}else{
													log.info("checkSync: no server update needed , sync end");
													syncStatusPromise.resolve(true); 
												}
											  
										}
									} else {
										log.info("checkedSync: no getSyncedStatus data returned , sync end");
										self.isSync = false;
										syncStatusPromise.resolve(true);
									}

								} else {
									self.isSync = false;
									syncStatusPromise.resolve(true);
								}	
							});
						});
				} else {
					self.isSync = false;
					syncStatusPromise.resolve(true);
				}
				return syncStatusPromise.promise;
			};
			

			function cleanupChart(chart, chartContainerId){
				if(!chart){
					console.warn('Could not cleanup chart, chart is not defined');
					return;
				}
				try {
					// Kill hidden resize monitor div
					const monitor = chart.canvas?.parentNode?.querySelector('.chartjs-size-monitor');
					monitor?.remove();

					// Destroy Chart instance and internal bindings
					chart.destroy();

					// Remove DOM canvas node
					chart.canvas?.remove();

					// Null all Chart object references
					chart.canvas = null;
					chart.ctx = null;
					chart.config = null;
					chart.scales = null;
					chart.$context = null;
					if (chart.chartArea) {
						chart.chartArea = null;
					}
				} catch (e) {
					console.warn('Error cleaning up chart: ', e);
				}

				// Remove any jQuery-bound handlers (if any were used)
        		$(chartContainerId).off();
			}
			$s.$on("$destroy", function() {
				deregOnFarmChange();
				deregOnlineCheckWatch();
				// clean up charts 
				cleanupChart($s.overallSummaryPieChart.chart, '#overallSummaryPieChart');
				cleanupChart($s.categoryBarChart.chart, '#categoryBarChart');
				_.forEach($s.categoryPieCharts, (chartDataObj) => {
					cleanupChart(chartDataObj.chart, '[id^="circle-chart-"]');
				});
				$s.overallSummaryPieChart = null;
				$s.sectionBarChart = null;
				$s.categoryPieCharts = null;
				$s.performanceContext = null;
			});
			
			deregOnFarmChange =	$s.$on('farm:changed',function(){
									MSF.loadPage('Fertility360report');
								});

			MSF.ready(function onMsfReady() {
				//console.log("MSF is ready, loading report data for audit id: "+self.auditId+" on F360 Published Report 2.0");
				$s.performanceContext = perfContextSvc.createPerformanceContext(_.get(MSF.getActiveHerd(),'herdId', null))
				$s.codeFile = _.cloneDeep(_.get(MSF,'lists.codeFile',[]));
				var currentAuditApiVersionJsonArray =  JSON.parse(_.get(_.find($s.codeFile,{codeType: "CURRENTAPIVERSIONS",code:"AUDIT"}),'detailsJson'));
				$s.currentAuditApiVersion = _.get(currentAuditApiVersionJsonArray[0],'value');

				//local storage data 	
				var mySynchStateJSON = localStorage.getItem('MySynch-state');
				if(!_.isUndefined(mySynchStateJSON)){
					$s.mySynchState = JSON.parse(mySynchStateJSON);

					$s.activeFarm = _.get($s.mySynchState,'value.activeFarm',{});
				}

				auditService.getActiveOrCurrentAuditVersion($s.performanceContext).then(function(apiVersion){
					$s.auditApiVersion = apiVersion;
			    });

				$s.codeFileCurrentF360CategoryApiVersions = _.map(_.filter($s.codeFile, { codeType: "CURRENTAPIVERSIONS", code: "F360CATEGORY" }), function (codeFileItem) {
					var detailsJson = _.get(codeFileItem, 'detailsJson', '[]');
					try {
						var detailsJsonArray = JSON.parse(detailsJson);
						_.set(codeFileItem, 'detailsJson', detailsJsonArray);
						return codeFileItem;
					} catch (e) {
						log.error("Falied To parse F360 Category Api Version in codeFileCurrentF360CategoryApiVersions");
						return {};
					}
				});
				$s.currentF360CategoryApiVersion = _.get($s.codeFileCurrentF360CategoryApiVersions, '[0].detailsJson[0].value', 'v2.0');

				$s.codeFileQuestionSections = _.map(_.filter($s.codeFile, { codeType: "F360SECTION" }), function (codeFileSection) {
					var detailsJson = _.get(codeFileSection, 'detailsJson', '[]');
					try {
						var detailsJsonArray = JSON.parse(detailsJson);
						_.set(codeFileSection, 'detailsJson', detailsJsonArray);
						return codeFileSection;
					} catch (e) {
						log.error("Falied To parse F36Section DetailsJson in codeFileQuestionSections");
						return {};
					}
				});
				$s.codeFileQuestionSectionSubheadings = _.map($s.codeFileQuestionSections, function (codeFileSection) {
					try {

						var sectionSubheadings = _.get(codeFileSection, 'detailsJson[0].subHeadings', []);



						return _.extend(
							{ sectionCode: _.get(codeFileSection, 'code') },
							{ sectionSubheadings: sectionSubheadings }
						);

					} catch (e) {
						log.error("Falied To parse F36Section DetailsJson");
						return {};
					}
				});

				$s.codeFileQuestionCategories = _.filter(_.map(_.filter($s.codeFile, { codeType: "F360CATEGORY" }), function (codeFileCategory) {
					var detailsJson = _.get(codeFileCategory, 'detailsJson', '[]');
					try {
						var detailsJsonArray = JSON.parse(detailsJson);
						_.set(codeFileCategory, 'detailsJson', detailsJsonArray);
						return codeFileCategory;
					} catch (e) {
						log.error("Falied To parse F360Category DetailsJson in codeFileQuestionCategories ");
						return {};
					}
				}), function (codeFileQuestionCategory) {
					var categoryApiVersion = _.get(codeFileQuestionCategory, 'detailsJson[0].apiVersion');
					if (_.isEqual(categoryApiVersion, $s.currentF360CategoryApiVersion)) {
						return codeFileQuestionCategory;
					}
				});
				$s.codeFileQuestionSubCategories = _.map($s.codeFileQuestionCategories, function (codeFileCategory) {
					try {

						var subCategories = _.get(codeFileCategory, 'detailsJson[0].SubCategories', []);



						return _.extend(
							{ categoryCode: _.get(codeFileCategory, 'code') },
							{ subCategories: subCategories }
						);

					} catch (e) {
						log.error("Falied To parse F360Category DetailsJson");
						return {};
					}
				});

				$s.codeFileQuestionOrders = _.map(_.filter($s.codeFile, { codeType: "F360REPORTORDER" }), function (codeFileQuestionOrder) {
					var detailsJson = _.get(codeFileQuestionOrder, 'detailsJson', '[]');
					try {
						var detailsJsonArray = JSON.parse(detailsJson);
						_.set(codeFileQuestionOrder, 'detailsJson', detailsJsonArray);
						return codeFileQuestionOrder;
					} catch (e) {
						log.error("Falied To parse F360 Order DetailsJson in codeFileQuestionOrders ");
						return {};
					}
				});
				$s.codeFileQuestionSubtitles = _.map($s.codeFileQuestionOrders, function (codeFileQuestionOrder) {
					try {

						var subtitles = _.get(codeFileQuestionOrder, 'detailsJson[0].subTitles', []);



						return _.extend(
							{ orderCode: _.get(codeFileQuestionOrder, 'code') },
							{ subtitles: subtitles }
						);

					} catch (e) {
						log.error("Falied To parse F360 Order DetailsJson");
						return {};
					}
				});

				// add dispaly version of categories for comments in $s.report
				_.forEach($s.report.resultsWriteRptJson.comments, function (comment) {
					var categoryDisplayValue = _.get(_.find($s.codeFileQuestionCategories, { code: comment.category }), 'codeValue');
					_.set(comment, 'categoryDisplay', categoryDisplayValue);
				});


				
				// first we want to check if the user has permissions to view this page/audit
				$s.checkPermissions(function(){
					// then we have to check if the server or the device needs updating 
					$s.syncInProgress = true;
					$s.initCheckSyncInProgress = true;
					$s.checkF360SyncStatus().then(function(){
						$s.syncInProgress = false;
						$s.initCheckSyncInProgress = false;
					
						// then as long as the user wasn't kicked back to the dashboard, continue to load this screen's data
						perfMetricSvc.startTiming("Page:F360PublishedReport:Render");
					 	loadCurrentHerd(() => {
							loadReportData().then(() => {
								perfMetricSvc.markPageReady("Page:F360PublishedReport:Render", $s.performanceContext);
							});
						 });		
						
					});

				}); 
			
			});
		}
	]);
})();
